// extracted by mini-css-extract-plugin
export default {"bottomCtas":"ForgotPasword_bottomCtas__ieU0a"};